import DataService from "@shared/services/DataService";

export const COMPLAINT_MODULE = "COMPLAINT";
export const COMPLAINT_WEB_VIEW_EVENTS = {
    COMPLAINT_CLOSE: "COMPLAINT_CLOSE",
    COMPLAINT_BACK: "COMPLAINT_BACK",
    ERROR_CLOSE: "ERROR_CLOSE"
};

export const FEEDBACK_MODULE = "FEEDBACK";
export const FEEDBACK_WEB_VIEW_EVENTS = {
    FEEDBACK_CLOSE: "FEEDBACK_CLOSE",
    FEEDBACK_BACK: "FEEDBACK_BACK",
    ERROR_CLOSE: "ERROR_CLOSE",
    BENE_BACK: "BENE_BACK",
    BENE_CLOSE: "BENE_CLOSE"
};

// Types supported by the render-check API
export const RENDER_CHECK_TYPES = {
    ADD_BENEFICIARY: "ADD_BENEFICIARY",
    POST_TRANSACTION: "POST_TRANSACTION"
};

const generateToken = async module => {
    let token = "";
    try {
        const res =
            // DUMMY_GENERATE_TOKEN_API_RESPONSE ||
            await DataService.get("generateSupportToken", { module });
        // console.log({ res });
        if (res.status === "200") {
            token = res.results[0].token;
        }
    } catch (error) {
        console.error("Error while generating Support Web view token ", error);
    } finally {
        return token;
    }
};

export default generateToken;

const DUMMY_GENERATE_TOKEN_API_RESPONSE = {
    timestamp: 1764401125818,
    status: "200",
    error: null,
    exception: null,
    message: null,
    warningKey: null,
    path: null,
    redirectUrl: null,
    messageKey: null,
    statusKey: "SUCCESS",
    meta: null,
    errors: null,
    warnings: null,
    logs: null,
    warningFlags: {
        value: 0
    },
    data: null,
    results: [
        {
            token: "S6cOhVRI150LvjNgwv7eJFs5IyVsjlbOYXUGorOlKTkX1yWqvTgVGx8z8GXtLA+eceLkUltiGxHaZhk9W2Y5mp/AgPD7yiJXTuSP56lqmQA="
        }
    ],
    traceId: "TXH-xxxxx-8OFXXgtHJYe-000000-xxx-8OFXXgtHJYf",
    traceid: "TXH-xxxxx-8OFXXgtHJYe-000000-xxx-8OFXXgtHJYf",
    signature: "27b316694a433f00932e8be567b9753b"
};

const DUMMY_GENERATE_TOKEN_API_RESPONSE_FEEDBACK = {
    timestamp: 1764403476954,
    status: "200",
    error: null,
    exception: null,
    message: null,
    warningKey: null,
    path: null,
    redirectUrl: null,
    messageKey: null,
    statusKey: "SUCCESS",
    meta: null,
    errors: null,
    warnings: null,
    logs: null,
    warningFlags: {
        value: 0
    },
    data: null,
    results: [
        {
            token: "lPP/qP/SVi0cfswYK18vP+LcZe7i6YmPBToJcjt4MS/Z3kPFvZY/J8SWQTkD+6L5kaz/znIsssGTHuqqVDQfqTsomWisZ7Igyr1BqIhAxZk="
        }
    ],
    traceId: "TXH-xxxxx-8OFXXgtHJYe-000000-xxx-8OFXXgtHJYf",
    traceid: "TXH-xxxxx-8OFXXgtHJYe-000000-xxx-8OFXXgtHJYf",
    signature: "64b24ec3168e28e70489a5df59f3e2cd"
};

/**
 * New v2 token generator (used by FEEDBACK add-beneficiary / transaction flow)
 *
 * Returns the full results[0] object (customerId, accessToken, redirectAccessToken, etc.)
 * or null if the call failed.
 */
export const generateFeedbackToken = async () => {
    try {
        const res = await DataService.get("generateSupportTokenV2");
        if (res.status === "200" && res.results?.length) {
            return res.results[0];
        }
        return null;
    } catch (error) {
        console.error("Error while generating Feedback v2 Web view token ", error);
        return null;
    }
};
